import React from 'react';
import styled from 'styled-components';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import RadarChart from '../RadarChart';
import icono from '../imgs/icons/edu_iconos_binoculars.svg';

export const ChartWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 500px;
  width: 100%;
  position: relative;
  ${'' /* bug with polar lines on radar pdf print */}
  @media print {
    svg {
      g {
        line {
          opacity: 0;
        }
      }
    }
  }
`;

const VocationOnePreferencesGraphPage = ({ user, background, number }) => {
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>2.2. Mapa de preferencias</h2>
          <p className='justified'>
            El siguiente mapa te muestra cómo se expresan tus preferencias en
            relación al resto de las preferencias del modelo:
          </p>
          <ChartWrapper>
            <RadarChart user={user} />
          </ChartWrapper>
          <br />

          <div style={{ position: 'relative' }}>
            <div style={{ position: 'absolute', top: -45, left: -25 }}>
              <img
                src={icono}
                alt='icono binoculares'
                style={{ width: 100, height: 'auto' }}
              />
            </div>
            <div className='edu-bubble-group bg-edu-red'>
              <p className='justified'>
                El mapa de preferencias te permite observar si tus intereses se
                agrupan en un mismo sector (p.e., todas se relacionan con el
                trabajo con personas), o si tienes intereses más variados, lo
                que se refleja en puntajes altos en áreas muy distintas (por
                ejemplo, atracción por Artes y Administración al mismo tiempo).
                Es normal que esto ocurra, podemos sentir atracción por
                actividades muy distintas,{' '}
                <strong>
                  lo importante es investigar cuál puede ser el mejor camino
                  para poder desplegar todos tus intereses, aunque sean muy
                  distintos.
                </strong>{' '}
                (Siguiendo el ejemplo, podemos estudiar Artes Visuales y luego
                tomar una especialización en Gestión Cultural).
              </p>
              <p className='justified'>
                <strong>
                  Además, ¡No te preocupes! hoy en día hay muchas carreras que
                  combinan disciplinas muy distintas (piensa por ejemplo en la
                  Ingeniería Biomédica, que combina aspectos de la medicina y la
                  ingeniería)
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default VocationOnePreferencesGraphPage;
